import styled from "styled-components";

export const TitleContainer = styled.div`
    margin-top: 8px;
    padding: 8px 16px;
    border-bottom: 1px solid #e6e6e6;
    border-bottom-color: rgba(0,0,0,.1);
`;